<template>
  <div class="order__filters">
    <div class="order__filters-group">
      <button
        v-for="status in statusOptions"
        :key="status"
        @click="$emit('input', { ...value, status })"
        class="order__filter"
        :class="{ 'order__filter-active': value.status === status }"
      >
        {{ $t(`orders.statusFilters.${status}`) }}
      </button>
    </div>

    <div class="order__filters-group">
      <SearchField label="UUID" name="uuid" :placeholder="$t(`orders.uuidSearch`)" v-model="uuid" @input="loadData" />
    </div>

    <div class="order__filters-group">
      <DateRangePicker
        v-model="dateRange"
        :maxDate="new Date()"
        @update="loadData"
        opens="left"
        :localeData="localeData"
        :ranges="ranges"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'

import { DATEPICKER_LOCALE_DATA, DATEPICKER_RANGES } from '@/views/config'

import SearchField from '@/components/Form/Search/SearchField.vue'

export default {
  name: 'OrdersFilters',
  inject: ['companyUser'],
  components: {
    DateRangePicker,
    SearchField,
  },
  props: {
    value: { type: Object, required: true },
  },
  data: () => ({
    dateRange: { startDate: moment().subtract(1, 'weeks').toDate(), endDate: new Date() },
    uuid: '',
  }),
  methods: {
    async loadData() {
      this.$emit('input', {
        ...this.value,
        from: this.dateRange.startDate,
        to: this.dateRange.endDate,
        uuid: this.uuid,
      })
    },
  },
  computed: {
    localeData() {
      return DATEPICKER_LOCALE_DATA[this.companyUser.user.language]
    },
    ranges() {
      return DATEPICKER_RANGES[this.companyUser.user.language]
    },
    statusOptions() {
      return ['open', 'assigned', 'done', 'closed', 'invoiced', 'all']
    },
    sortingAscending() {
      return {
        // Active orders are handled FIFO, so the oldest should come up first
        open: true,
        assigned: true,
        done: true,
        // Past orders are not of much interest - rather newer than older ones
        closed: false,
        invoiced: false,
        all: false,
      }[this.status]
    },
  },
  watch: {
    async value() {
      const query = this.$router.currentRoute.query
      const { period, status } = this.value
      const uuid = this.value.uuid ? this.value.uuid.trim() : ''

      const currentDateRange = {
        from: moment(this.dateRange.startDate).format('YYYY-MM-DD'),
        to: moment(this.dateRange.endDate).format('YYYY-MM-DD'),
      }

      if (
        status == query.status &&
        query.from == currentDateRange.from &&
        query.to == currentDateRange.to &&
        query.uuid == uuid
      )
        return

      this.$router.push({
        query: {
          ...query,
          period,
          status,
          from: currentDateRange.from,
          to: currentDateRange.to,
          uuid: uuid,
        },
      })
    },
  },
  mounted() {
    const { from, to, status, uuid } = this.$router.currentRoute.query
    this.dateRange.startDate = moment(from, 'YYYY-MM-DD', true).isValid() ? from : this.dateRange.startDate
    this.dateRange.endDate = moment(to, 'YYYY-MM-DD', true).isValid() ? to : this.dateRange.endDate
    this.uuid = uuid

    this.$emit('input', {
      status: status || this.statusOptions[0],
      from: this.dateRange.startDate,
      to: this.dateRange.endDate,
      uuid: uuid,
    })
  },
}
</script>

<style>
@import './OrdersFilters.css';

.order__filters {
  /*
    The SearchField component has a bottom-margin that we don't want here. By changing
    it, the search icon is misplaced so we need to correct that, too.
  */
  .search {
    margin-bottom: 0;
  }

  .search-icon {
    top: 42%;
  }

  .search-field {
    height: 30px;
  }
}
</style>
